<template>
  <v-tooltip bottom :value="showTooltip" color="black" :max-width="300">
    <template #activator="{attrs}">
      <div v-bind="attrs" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave" class="m-button-select-tooltip">
        <m-button-select ref="buttonSelect" v-bind="$attrs" v-on="$listeners" />
      </div>
    </template>
    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script lang="ts">
import {defineComponent, onBeforeUnmount, onMounted, ref} from '@vue/composition-api'

export default defineComponent({
  name: 'MButtonSelectTooltip',
  inheritAttrs: false,
  setup(_, {refs, root}) {
    const showTooltip = ref(false)
    const tooltipText = ref('')
    let unwatchFn: (() => void) | null = null
    let showTimeout: ReturnType<typeof setTimeout> | null = null

    onMounted(() => {
      root.$nextTick(() => {
        const instance = refs.buttonSelect as any
        if (instance) {
          instance.titleText = ''
          unwatchFn = instance.$watch('isOpen', (val: boolean) => {
            if (val) {
              clearShowTimeout()
              showTooltip.value = false
            }
          })
        }
      })
    })

    onBeforeUnmount(() => {
      if (unwatchFn) unwatchFn()
      clearShowTimeout()
    })

    function clearShowTimeout() {
      if (showTimeout) {
        clearTimeout(showTimeout)
        showTimeout = null
      }
    }

    function onMouseEnter() {
      const instance = refs.buttonSelect as any
      if (!instance) return

      instance.titleText = ''

      const textEl = instance.$refs?.textEl as HTMLElement | undefined
      if (!textEl) return

      const isTruncated = textEl.scrollWidth > textEl.clientWidth
      tooltipText.value = instance.displayValue || ''

      if (isTruncated && !instance.isOpen) {
        showTimeout = setTimeout(() => {
          showTooltip.value = true
        }, 300)
      }
    }

    function onMouseLeave() {
      clearShowTimeout()
      showTooltip.value = false
    }

    return {
      showTooltip,
      tooltipText,
      onMouseEnter,
      onMouseLeave,
    }
  },
})
</script>
